// extracted by mini-css-extract-plugin
export default {"labelText":"ReadOnlyField_labelText__8Fnen","fieldText":"ReadOnlyField_fieldText__KXZa6"};